import React from "react";
import { Toaster } from "sonner";
import { AdminAuthProvider, useAdminAuth } from "../../context/AdminAuth";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

function AdminGate() {
  const { status } = useAdminAuth();
  if (status === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0c1622] text-white">
        Loading…
      </div>
    );
  }
  return status === "in" ? <AdminDashboard /> : <AdminLogin />;
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Toaster position="top-center" richColors />
      <AdminGate />
    </AdminAuthProvider>
  );
}
